import React from "react";
import './styles.css'
export class Bloco extends React.Component {
    render() {
        return (
            <div className="target_bloco">
                <h3 className="target_bloco-titulo">{this.props.tituloBloco}</h3>
                <p className="target_bloco-texto">{this.props.textoBloco}</p>
            </div>
        );
    }
}